import script from "./PwaHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaHome.vue?vue&type=script&setup=true&lang=ts"

import "./PwaHome.vue?vue&type=style&index=0&id=e40f6c24&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e40f6c24"]])

export default __exports__